import { useTranslation } from '@wix/yoshi-flow-editor';

export const createTypedUseTranslate =
  <TranlsationKeyType extends string>() =>
  () => {
    const { t } = useTranslation();
    return t as (key: TranlsationKeyType, params?: any) => string;
  };
